import React from 'react'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import InputControl from '../../components/InputControl'
import { Controller, useForm } from 'react-hook-form'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { statemanagement, industrymanagement, faqsubcategory } from '../../Routes/routingConsts'
import { Dropdown, Form, InputGroup, Button } from 'react-bootstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import Swal from 'sweetalert2'
import DropDownControlForLocation from '../../components/DropDownControlForLocation'
import DropDownControlForCategery from '../../components/DropDownControlForCategery/DropDownControlForCategery'

const AddEditFaqSubCategory = () => {
    const FaqCategoryValidationInput = yup.object({
        name: yup.string().required('Please enter sub-category name'),
       
        category: yup.object().test('one-of', 'Please select cateogy', (val) => {
            return (
                val?.categoryName !== '' && val?.categoryId !== '' && Boolean(val)
            )
        })
    })
    const {
        handleSubmit,
        reset,
        register,
        control,
        formState: { errors }
    } = useForm({ resolver: yupResolver(FaqCategoryValidationInput) })
    const navigate = useNavigate()
    const { countryId, subCategoryId } = useParams()

    // add - edit state ///
    async function addNewState({category:{categoryId},name,...rest} ) {

        if (subCategoryId) {
            alert("subCategoryId Edit",subCategoryId)
            return await requestApi
                .post(
                    `faqSubCategory/add-edit`,
                    { faqsubCategoryId:subCategoryId, subCategoryName:name, faqCategoryId: categoryId},
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        } else {
            alert("subCategoryId Add",subCategoryId)
            // let countryName = JSON.parse(country)
            return await requestApi
                .post(
                    `faqSubCategory/add-edit`,
                    {subCategoryName:name, faqCategoryId: categoryId },
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        }
    }

    const mutation = useMutation(addNewState, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            }).then(() => {
                navigate(faqsubcategory)
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    // End add-edit state////

    // view-state on id //
    async function viewStateOnId() {
        return await requestApi
            .post(`/faqSubCategory/view`, { subCategoryId }, { headers: true })
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['view-state'],
        queryFn: () => viewStateOnId(subCategoryId),
        enabled: !!subCategoryId,
        onSuccess: ({data}) => {
            console.log(data,'data')
            reset({

           
                category: {
                    categoryId: data?.categoryId,
                    categoryName: data?.categoryName
                },
                name: data?.subCategoryName

            })
        }
    })
    // end view state on id //

    ///// list category Api ////
    async function countryList() {
        return await requestApi.post(
            `faqCategory/list`,
            { limit: 550 },
            { headers: true }
        )
    }
    const { data: categoryDataList } = useQuery({
        queryKey: ['faqCategory'],
        queryFn: () => countryList('country')
        // enabled: !!userProfile
    })
    /////end category list api ///

    const onSubmit = ({ ...data }) => {
        const payload = {
            ...data
        } 
        mutation.mutate(payload)
        console.log("dhngkghjkfhgjh");
    }
    return (
        <>
            <div className="sidebar-content add-edit-category common-page">
                <ul className="nav-links">
                    <Link to={statemanagement}>
                        <li>
                            <a href="">Sub-Category Management</a>
                            <span>&gt;</span>
                        </li>
                    </Link>
                    <li>
                        {subCategoryId ? (
                            <a className="bold">Edit Sub-Category</a>
                        ) : (
                            <a className="bold">Add Sub-Category</a>
                        )}
                    </li>
                </ul>

                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="whitebox">
                        {subCategoryId ? (
                            <div className="title-text">
                                <h3>Edit Sub-Category</h3>
                            </div>
                        ) : (
                            <div className="title-text">
                                <h3>Add Sub-Category</h3>
                            </div>
                        )}

                        <div className="createnew-box newbox">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">  
                                        <DropDownControlForCategery
                                            id={true}
                                            isDisabled={subCategoryId && 'true'}
                                            // isDisabled={true}
                                            name="category"
                                            label="Category Name"
                                            control={control}
                                            options={
                                                categoryDataList?.data?.data
                                            }
                                            // className="icontrol"
                                            register={register}
                                            error={errors.Category?.message}
                                            // getCountry={(countryId) => {
                                            //     // setCountryId()
                                            //     // setValue('city', JSON.stringify({ _id: '', name: '' }))
                                            // }}
                                        />
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <InputControl
                                            label="Sub-Category Name"
                                            name="name"
                                            register={register}
                                            // placeholder='State Name'
                                            error={errors?.name?.message}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    <div className="jobdes-btn">
                  
                        <ButtonWithLoader
                            isLoading={mutation?.isLoading}
                            cssClass="common-btn comman-auth-btn reset-btn"
                        >
                            {subCategoryId ? (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Edit
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Add
                                </button>
                            )}
                        </ButtonWithLoader>
                        <button
                            type="button"
                            className="common-btn cancel"
                            onClick={() => {
                                navigate(faqsubcategory)
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                    </div>
                </Form>
            </div>
        </>
    )
}

export default AddEditFaqSubCategory

